var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("treeselect", {
        attrs: {
          value: _vm.value,
          placeholder: "Seleccione Entidad",
          options: _vm.entities
        },
        on: { input: _vm.onInput }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }